import { render } from "./CheckboxControl.vue?vue&type=template&id=2ca52509"
import script from "./CheckboxControl.vue?vue&type=script&lang=js"
export * from "./CheckboxControl.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Mobile\\registration\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__